import React from 'react';
import MyPhoto from '../static/images/mauricio-githubphoto.jpg';
import MyResume from '../static/resume/Mauricio_Gonzalez_s_Resume.pdf';
import { FileDown } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import CommandHeader from "../components/CommandHeader";

function AboutMe() {
    return (
        <div className="mx-auto max-w-3xl px-6 py-12">
            <CommandHeader command="cat about.md" />
            <h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">About me</h1>

            <Card className="mt-8 overflow-hidden">
                <div className="sm:flex">
                    <img
                        src={MyPhoto}
                        alt="Mauricio Gonzalez"
                        className="h-56 w-full object-cover sm:h-auto sm:w-56"
                    />
                    <CardContent className="p-6">
                        <p className="text-sm leading-relaxed text-muted-foreground">
                            I'm Mauricio Gonzalez, a first-generation Hispanic backend engineer. I work
                            at bet365, building Go microservices and backend APIs for high-volume
                            trading systems. I liked computers early, but the idea of being a hacker is
                            what actually pulled me into computer science, and I still go to DEF CON
                            every year. I got my B.S. at Colorado State University with a concentration
                            in Networks and Security. Before bet365 I was a Network Support Engineer at
                            Cisco Meraki. At CSU I was a Python teaching assistant, an IT lab
                            technician, and a lead mentor for first-generation Latinx computer science
                            students. I still keep in touch with those mentees.
                        </p>
                        <Button className="mt-5" asChild>
                            <a href={MyResume} download="Mauricio_Gonzalez_Resume.pdf">
                                <FileDown /> Download resume
                            </a>
                        </Button>
                    </CardContent>
                </div>
            </Card>

            <div className="mt-6 grid gap-6 sm:grid-cols-2">
                <Card>
                    <CardContent className="p-6">
                        <h2 className="text-lg font-semibold">Interests</h2>
                        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                            I play chess, which I picked up during summers at Groundwork Denver.
                            Wrestling in high school taught me hard work and commitment. These days I
                            hike, train jiu-jitsu, and go to DEF CON every summer.
                        </p>
                    </CardContent>
                </Card>
                <Card>
                    <CardContent className="p-6">
                        <h2 className="text-lg font-semibold">What drives me</h2>
                        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                            With code you can build a solution to almost anything, which is most of why
                            I do this. Years of community work with nonprofits are the other half. I
                            want to build things people actually use, and help the people coming up
                            behind me.
                        </p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}

export default AboutMe;
